// src/pages/factors/PrintTypeModal.jsx
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function PrintTypeModal({ factor, onClose }) {
  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  const types = [
    {
      to: `/dashboard/factors/${factor.id}/print`,
      icon: 'fa-file-lines',
      title: 'نوع ۱',
      desc: 'صورتحساب رسمی (فرم استاندارد)',
    },
    {
      to: `/dashboard/factors/${factor.id}/print2`,
      icon: 'fa-file-invoice',
      title: 'نوع ۲',
      desc: 'فاکتور فروش با لوگو، مهر و امضا (A4 عمودی)',
    },
  ];

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()}>
        <div className="modal-head">
          <h2>نوع چاپ فاکتور {factor.serial}</h2>
          <button type="button" className="modal-close" onClick={onClose} aria-label="بستن">
            <i className="fa-solid fa-xmark" />
          </button>
        </div>

        <div className="print-type-list">
          {types.map((t) => (
            <Link
              key={t.to}
              to={t.to}
              target="_blank"
              rel="noopener noreferrer"
              className="print-type-card"
              onClick={onClose}
            >
              <span className="print-type-icon">
                <i className={`fa-solid ${t.icon}`} />
              </span>
              <span>
                <div className="print-type-title">{t.title}</div>
                <div className="muted">{t.desc}</div>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}